@if (alertService.data) {
<div
	class="content-alert fullscreen vertical-align"
	[@openClose]="alertService.data && alertService.data.show ? 'open' : 'closed'"
>
	@if (alertService.data.title === 'Renovar Plan' && divVisible) {
	<div class="overlay" (click)="toggleDiv()">
		<div class="d-flex justify-content-between align-items-center">
			<h5 class="modal-title fs-18 fw-500 m-0">
				{{ alertService.data.title }}
			</h5>
			<i class="bi bi-x-lg close-icon" role="button" (click)="close(false)"></i>
		</div>
		<hr />
		<div class="text-center">
			@if (alertService.data.icon) {
			<div>
				@if (alertService.data.type === 0) {
				<em class="bi icon text-primary" [class]="alertService.data.icon"></em>
				} @if (alertService.data.type === 1) {
				<em class="bi icon text-warning" [class]="alertService.data.icon"></em>
				} @if (alertService.data.type === 2) {
				<em class="bi icon text-danger" [class]="alertService.data.icon"></em>
				}
			</div>
			} @if (alertService.data.subtitle) {
			<div>{{ alertService.data.subtitle }}</div>
			} @if (alertService.data.message) {
			<div>
				<br />
				<div class="fw-bold">{{ alertService.data.message }}</div>
			</div>
			}
			<br />
			<div class="alert-footer">
				@if (alertService.data.cancelButtonText) {
				<button (click)="close(false)" class="btn btn-outline-primary">
					{{ alertService.data.cancelButtonText }}
				</button>
				}
				<button (click)="close(true)" class="btn btn-primary">
					{{ alertService.data.confirmButtonText }}
				</button>
			</div>
		</div>
	</div>
	} @if (alertService.data.title !== 'Renovar Plan') {
	<div class="content">
		<div class="d-flex justify-content-between align-items-center">
			<h5 class="modal-title fs-18 fw-500 m-0">
				{{ alertService.data.title }}
			</h5>
			<i class="bi bi-x-lg close-icon" role="button" (click)="close(false)"></i>
		</div>
		<hr />
		<div class="text-center">
			@if (alertService.data.icon) {
			<div>
				@if (alertService.data.type === 0) {
				<em class="bi icon text-primary" [class]="alertService.data.icon"></em>
				} @if (alertService.data.type === 1) {
				<em class="bi icon text-warning" [class]="alertService.data.icon"></em>
				} @if (alertService.data.type === 2) {
				<em class="bi icon text-danger" [class]="alertService.data.icon"></em>
				}
			</div>
			} @if (alertService.data.subtitle) {
			<div>{{ alertService.data.subtitle }}</div>
			} @if (alertService.data.message) {
			<div>
				<br />
				<div class="fw-bold">{{ alertService.data.message }}</div>
			</div>
			}
			<br />
			<div class="alert-footer">
				@if (alertService.data.cancelButtonText) {
				<button (click)="close(false)" class="btn btn-outline-primary">
					{{ alertService.data.cancelButtonText }}
				</button>
				}
				<button (click)="close(true)" class="btn btn-primary">
					{{ alertService.data.confirmButtonText }}
				</button>
			</div>
		</div>
	</div>
	}
</div>
}
